import Coupons from "pages/coupons";
import CouponDetail from "pages/coupons/details";

const routes = [
  // coupon
  {
    path: `/vouchercodes`,
    exact: true,
    auth: true,
    component: Coupons,
  },
  // coupon detail
  {
    path: `/coupons/:couponId`,
    exact: true,
    auth: true,
    component: CouponDetail,
  },
  // create coupon code
  {
    path: `/coupon/create`,
    exact: true,
    auth: true,
    component: CouponDetail,
  },
];

export default routes;
